import JJCard from "../assets/images/jj-card.png";

const jj_card = {
    slug: "JJ_Detailing_Carte_Visite",
    sections: [
        {
            elements: [
                { type: "title-prc", content: "Carte de visite JJ Detailing" },
                { type: "tex-prc", content: "Création d'une identité visuelle professionnelle pour une entreprise de detailing automobile en pleine expansion." },
                { type: "imageTitle", src: JJCard, alt: "Carte de visite JJ Detailing" }
            ]
        },
        {
            elements: [
                { type: "title", content: "Contexte du projet" },
                { type: "text", content: "JJ Detailing, une entreprise de detailing automobile souhaitant développer sa notoriété, m'a contacté pour travailler sur son identité visuelle. Le projet a débuté par la refonte d'un logo existant qui nécessitait une modernisation pour mieux refléter le professionnalisme de l'entreprise." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Refonte du logo" },
                { type: "text", content: "La première étape a consisté à retravailler le logo existant du client. L'objectif était de conserver l'essence de la marque tout en apportant une touche plus moderne et professionnelle. Cette nouvelle identité visuelle allait servir de base pour l'ensemble des supports de communication." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Conception de la carte de visite" },
                { type: "text", content: "Une fois le logo finalisé, j'ai pu me concentrer sur la création de la carte de visite. Le client m'a fourni les informations essentielles à intégrer : coordonnées, services proposés et slogan. Mon rôle a été de structurer ces éléments de manière harmonieuse en créant un design épuré et professionnel. La carte devait transmettre l'attention aux détails qui caractérise le detailing automobile." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Approche design" },
                { type: "text", content: "Le design adopte une palette de couleurs sobre et premium, avec une typographie claire et élégante. La mise en page équilibrée met en valeur le logo tout en assurant une lisibilité optimale des coordonnées. Des éléments graphiques subtils évoquant l'univers automobile viennent enrichir le visuel sans le surcharger." }
            ]
        },
        {
            elements: [
                { type: "title", content: "Résultat" },
                { type: "text", content: "La carte de visite imprimée sur papier premium avec finition mate renforce l'image haut de gamme de JJ Detailing. Ce support de communication efficace permet au client de se présenter professionnellement auprès de sa clientèle et de se démarquer dans le secteur compétitif du detailing automobile." }
            ]
        }
    ]
};

export default jj_card;